module.exports = __webpack_public_path__ + "media/stay-future-ready.260de013.svg";